/*eslint-disable prefer-const */
import React from 'react';
import Primary from './progressbar.scss';

const ProgressBar = (props) => {
  let { bgcolor, completed } = props;
  bgcolor = Primary.progressBarFillBg; //bgcolor ? bgcolor : Primary.progressBarFillBg;

  const containerStyles = {
    height: 15,
    backgroundColor: Primary.progressBarBg,
    borderRadius: 50,
  };

  const fillerStyles = {
    height: '100%',
    width: `${completed}%`,
    backgroundColor: bgcolor,
    borderRadius: 'inherit',
    textAlign: 'right',
  };

  return (
    <div style={containerStyles} className="progressbar">
      <div style={fillerStyles}></div>
    </div>
  );
};

export default ProgressBar;
